import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CodingOpportunities/patients`;

// helpers
const cleanStr = (v) => {
  if (v === null || v === undefined) return undefined;
  const s = String(v).trim();
  return s.length ? s : undefined;
};

const cleanNum = (v) => {
  if (v === null || v === undefined || v === "") return undefined;
  const n = Number(v);
  return Number.isFinite(n) ? n : undefined;
};

const cleanDate = (v) => {
  if (!v) return undefined;

  // Si te llega un Date
  if (v instanceof Date && !isNaN(v.getTime())) {
    const yyyy = v.getFullYear();
    const mm = String(v.getMonth() + 1).padStart(2, "0");
    const dd = String(v.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  }

  // Si te llega string: "YYYY-MM-DD" o similar
  const s = String(v).trim();
  return s.length ? s : undefined;
};

/**
 * Obtiene el listado paginado de PACIENTES con Coding Opportunities.
 *
 * filters = {
 *   pcpId,
 *   measureYear,
 *   memberType,
 *   cipId,
 *   patientName,
 *   dob,                   // Date | "YYYY-MM-DD"
 *   patientStatus,
 *   patientWorkflowStatus,
 *   locationId,
 *   networkName,
 *   memberPlan,
 *   page,
 *   pageSize
 * }
 */
const getCodingOpportunitiesPatients = async (filters = {}) => {
  try {
    const params = {
      // existing
      pcpId: cleanNum(filters.pcpId),
      measureYear: cleanNum(filters.measureYear),
      memberType: cleanStr(filters.memberType),

      // new
      cipId: cleanStr(filters.cipId),
      patientName: cleanStr(filters.patientName),
      dob: cleanDate(filters.dob),

      patientStatus: cleanNum(filters.patientStatus),
      patientWorkflowStatus: cleanNum(filters.patientWorkflowStatus),

      locationId: cleanNum(filters.locationId),

      networkName: cleanStr(filters.networkName),
      memberPlan: cleanStr(filters.memberPlan),

      // paging
      page: cleanNum(filters.page) ?? 1,
      pageSize: cleanNum(filters.pageSize) ?? 50,
    };

    const response = await axios.get(API_URL, {
      params,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return response.data; // { data, page, pageSize, total, totalPages }
  } catch (error) {
    console.error("Error fetching coding opportunities patients:", error);
    throw error;
  }
};

export default getCodingOpportunitiesPatients;
